import React, { useState } from "react";
import { Container, Row, Col, Image, Button, Modal } from "react-bootstrap";
import ShitCoin from "../../../assets/images/shitcoin-logo.png";
import CrossIcon from "../../../assets/images/cross-icon.svg";
import "./Banner.css";
import { Link } from "react-router-dom";
function Banner() {
  let [showModal, setShowModal] = useState(false);
  return (
    <>
      <div className="banner home-banner">
        <Container fluid className="custom-container">
          <Row className="align-items-center justify-content-between">
            <Col lg={5}>
              <div className="shit-coin-logo">
                <Image src={ShitCoin} fluid />
              </div>
            </Col>
            <Col lg={6}>
              <div className="content-wrapper">
                <strong className="welcome-heading">
                  Welcome to CoinMarketAlert’s
                </strong>
                <h1>SHITCOIN EXCHANGE</h1>
                <p className="banner-text">
                  GIVE US YOUR USELESS SHITCOINS AND RECEIVE REWARDS
                </p>
                <Button
                  variant="none"
                  className="wallet-btn"
                  onClick={() => setShowModal(!showModal)}
                >
                  Connect Your Wallet
                </Button>
                <p className="read-more">Or scroll down to read more...</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal className="modal-banner" show={showModal}>
        <button
          onClick={() => setShowModal(!showModal)}
          className="cancel-icon border-0"
        >
          <Image src={CrossIcon} fluid />
        </button>
        <div className="banner wallet-banner">
          <Container fluid className="custom-container">
            <Row className="align-items-center justify-content-between">
              <Col lg={5}>
                <div className="shit-coin-logo">
                  <Image src={ShitCoin} fluid />
                </div>
              </Col>
              <Col lg={6}>
                <div className="content-wrapper">
                  <strong className="choose-heading">CHOOSE YOUR WALLET</strong>
                  <ul className="wallet-list mb-0">
                    <li>
                      <Link
                        to="/chain"
                        className="text-white text-decoration-none"
                      >
                        MetaMask{" "}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/chain"
                        className="text-white text-decoration-none"
                      >
                        TrustWallet
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/chain"
                        className="text-white text-decoration-none"
                      >
                        Wallet Connect
                      </Link>
                    </li>
                  </ul>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </Modal>
    </>
  );
}

export default Banner;
